import { message } from 'antd';
// import intl from 'react-intl-universal';
import { getClient } from './client';
// import { Action, broadcast, scope } from '@/config/const.config';
// import { WALLET } from './const';
import { Storage } from './storage';
// import { getContract, contract } from '@/utils/evm';
export type Actor = {
  actor:string,
  permission:string
}
export type Action = {
  account: string; // 合约名称
  name: string; // 合约方法名
  data: any; // 合约参数
  authorization?: Actor[];
};
/**======================================AMAX=================================================**/

/**
 * amax
 * 调用合约
 */
export async function transact(actions: Action[]) {
  if (!Array.isArray(actions) || !actions.length) {
    return;
  }

  // 过滤出正确的action
  actions = addAuthorization(actions.filter((item:any) => checkAction(item)));

  // const wallet = Storage.getItem('wallet');

  try {
    // await insufficientCPUTip();
    return await scatter(actions);
    // if (wallet === WALLET.ANCHOR) {
    //   return await anchor(actions);
    // } else if (wallet === WALLET.SCATTER) {
    //   return await scatter(actions);
    // }
  } catch (e) {
    const error: any = typeof e === 'string' ? JSON.parse(e) : e;
    if (error?.error) {
      const { code, details = [] } = error.error;
      if (code === 3050003) {
        message.error(`${code}: ${details[0].message}`);
      } else {
        // message.error(`${code}: ${intl.get(code)}`);
      }
    }
    throw e;
  }
}

function checkAction(action: Action) {
  const { account, data, name } = action;
  if (!account || !data || !name) {
    return false;
  }
  return true;
}

/**
 * 给action增加authorization属性
 * @param actions
 * @returns
 */
function addAuthorization(actions: Action[]): Action[] {
  const walletAddress = Storage.getItem('walletAddress');
  const authority = Storage.getItem('authority');
  for (const action of actions) {
    if (!action.authorization || action.authorization.length === 0) {
      action.authorization = [
        {
          actor: walletAddress,
          permission: authority,
        },
      ];
    }
  }
  return actions;
}

/**
 * Scatter发起交易
 * @param actions
 * @returns
 */
async function scatter(actions: Action[]) {
  const client = await getClient();
  return await client.transaction({ actions });
}

/**
 * Anchor发起交易
 * @param actions
 * @returns
 */
// async function anchor(actions: Action[]) {
//   // @ts-ignore
//   const session = await window.__LINK__.restoreSession(scope);
//   return await session.transact({ actions }, { broadcast });
// }

/**
 * cpu不足提示
 */
// async function insufficientCPUTip() {
//   const walletAddress = Storage.getItem('walletAddress');
//   const client = getLocalClient();
//   const {
//     cpu_limit: { available },
//   } = await client.getAccount(walletAddress);
//   if (available < 200 * 1000) {
//     message.warning(intl.get('insufficientCPUTip'));
//     throw new Error(intl.get('insufficientCPUTip'));
//   }
// }

/**======================================EVM=================================================**/

/**
 * evm
 * 合约执行
 * 注意: param是数组，参数组成的数组，按顺序写，即使是一个参数
 */
// export async function evmTransact(
//   contract: contract,
//   action: string,
//   param: any[],
// ) {
//   const contractObj = await getContract(contract);
//   try {
//     return await contractObj[action](...param);
//   } catch (e: any) {
//     const { message: msg, code, error } = e;

//     /**
//      * 除了用户[拒绝]MetaMask请求
//      * 都会有错误提示
//      * ACTION_REJECTED是用户拒绝或者取消MetaMask请求
//      */
//     if (code !== 'ACTION_REJECTED') {
//       if (error?.data?.message) {
//         message.error(error.data.message);
//       } else {
//         message.error(intl.get(`EVMERRORCODE${code}`) || msg);
//       }
//     }
//     throw e;
//   }
// }
